import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  SwiperConfigInterface,
  SwiperPaginationInterface,
} from 'ngx-swiper-wrapper';
import { AppSwiperCarouselImage } from 'anchor-shared/lib/model/interface/carouselImage';

@Component({
  selector: 'app-swiper-carousel',
  templateUrl: './swiper-carousel.component.html',
  styleUrls: ['./swiper-carousel.component.scss'],
})
export class SwiperCarouselComponent implements OnInit, OnDestroy {
  @Input() appSwiperCarouselList: AppSwiperCarouselImage[];

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
  };

  public config: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 'auto',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    loop: true,
    pagination: this.pagination,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
  };

  constructor() {}

  ngOnInit() {}

  ngOnDestroy(): void {}

  onIndexChange(event: any): void {
    // do nothing
  }
}
